export default __webpack_public_path__ + "static/media/neuigkeiten.f3de3d3c.svg";